/**
 * Client-side pre-check for the paste-link tab (spec 04 §5.2 step 3 is the real validation — the server
 * normalises and detects the platform; 422 MEETING_URL_INVALID / PLATFORM_UNSUPPORTED render through
 * `conversationErrorMessage`). This only stops obviously wrong input before a request is made.
 */
const PLATFORMS = [
  { id: "zoom", hosts: [/(^|\.)zoom\.us$/, /(^|\.)zoom\.com$/] },
  { id: "meet", hosts: [/^meet\.google\.com$/] },
  { id: "teams", hosts: [/^teams\.microsoft\.com$/, /^teams\.live\.com$/] },
  { id: "webex", hosts: [/(^|\.)webex\.com$/] },
] as const;

export type MeetingPlatform = (typeof PLATFORMS)[number]["id"];

function meetingHost(url: string): string | null {
  try {
    const parsed = new URL(url.trim());
    if (parsed.protocol !== "https:") return null;
    return parsed.hostname.toLowerCase();
  } catch {
    return null;
  }
}

export function meetingPlatform(url: string): MeetingPlatform | null {
  const host = meetingHost(url);
  if (!host) return null;
  return PLATFORMS.find((platform) => platform.hosts.some((re) => re.test(host)))?.id ?? null;
}

export function isSupportedMeetingUrl(url: string): boolean {
  return meetingPlatform(url) !== null;
}
